(function ($) {
    /* Radiobuttons */
    $(document).on('change', '.__radio input', function () {
        if ($(this).is(':checked')) {
            $(this)
                .closest('.__radio')
                .find('.input_wrap > label')
                .removeClass('__checked');
            $(this)
                .parent()
                .addClass('__checked');
        }
    });
    $('.__radio input:checked')
        .parent()
        .addClass('__checked');

    /* Checkboxes */
    $(document).on('change', '.__checkbox input', function () {
        if ($(this).is(':checked')) {
            $(this)
                .parent()
                .addClass('__checked');
        } else {
            $(this)
                .parent()
                .removeClass('__checked');
        }
    });
    $('.__checkbox input:checked')
        .parent()
        .addClass('__checked');

    /* Focus state */
    $(document).ready(function () {
        $('.field_wrap.__radio input').focus(function () {
            $(this)
                .closest('label')
                .addClass('__focused');
        }).blur(function () {
            $(this)
                .closest('label')
                .removeClass('__focused');
        });
        $('.field_wrap.__checkbox input').focus(function () {
            $(this)
                .closest('label')
                .addClass('__focused');
        }).blur(function () {
            $(this)
                .closest('label')
                .removeClass('__focused');
        });
    });

    /* Reset checkboxes and dropdown selection */
    $('.__reset').click(function () {
        $('.__radio label').removeClass('__checked');
        $('.__checkbox label').removeClass('__checked');
        $('.__select .select2-selection__rendered').empty().addClass('__cleared');
        $('.__selectwithimages .select2-selection__rendered').empty().addClass('__cleared');
    })

    $(function () {
        $('.input_wrap').each(function () {
            const passwordField = $(this).find('.password');
            const togglePassword = $(this).find('.icon');

            togglePassword.on('click', function () {
                $(this).toggleClass('active');
                if ($(this).hasClass('active')) {
                    passwordField.attr('type', 'text');
                    togglePassword.removeClass('icon-visibility');
                    togglePassword.addClass('icon-visibility-off');
                } else {
                    passwordField.attr('type', 'password');
                    togglePassword.removeClass('icon-visibility-off');
                    togglePassword.addClass('icon-visibility');
                }
            });
        });
    });

    // Shift label position on focus or completion of input fields
    $(document).ready(function () {
        var exceptions = $('.gfield--type-choice, .gfield--type-time, .gfield--type-date, .gfield--type-fileupload, .gfield--type-multiselect, .gfield--type-select');
        // Check and update class based on input state
        function updateLabelClass() {
            $('.gform_wrapper .gfield, .ginput_complex > span').each(function () {

                if (!$(this).is(exceptions)) {
                    exceptions.addClass('hello');
                    const input = $(this).find('input, textarea, select');
                    const label = $(this).find('.gfield_label, .gform-field-label');
                    if (input.length > 0 && (input.is(':focus') || input.val().length > 0)) {
                        $(this).find(label).addClass('__label-shift');
                        $(this).find(input).addClass('__input-shift');
                    } else {
                        $(this).find(label).removeClass('__label-shift');
                        $(this).find(input).removeClass('__input-shift');
                    }
                }
            });
        }

        // Attach event listeners to input fields
        $('.ginput_container input, .ginput_container select, .ginput_container textarea').on('focus blur input change', function () {
            updateLabelClass();
        });

        updateLabelClass();
    });

    /* Radiobuttons */
    (function ($) {
        $(document).on('change', '.gfield_radio input', function () {
            if ($(this).is(':checked')) {
                $(this).parent().addClass('__checked');
                $(this).parent().siblings().removeClass('__checked');
            }
        });
    })(jQuery);

    (function ($) {
        $('.gfield_radio input:checked')
            .parent().addClass('__checked');
    })(jQuery);

    /* Checkboxes */
    (function ($) {
        $(document).on('change', '.gfield_checkbox input', function () {
            if ($(this).is(':checked')) {
                $(this).parent().addClass('__checked');
            } else {
                $(this).parent().removeClass('__checked');
            }
        });
    })(jQuery);

    $('.gfield_checkbox input:checked')
        .parent().addClass('__checked');

    /* Focus state */
    $(document).ready(function () {
        $('.gfield_radio input').focus(function () {
            $(this).parent().addClass('__focused');
        }).blur(function () {
            $(this).parent().removeClass('__focused');
        });
        $('.gfield_checkbox input').focus(function () {
            $(this).parent().addClass('__focused');
        }).blur(function () {
            $(this).parent().removeClass('__focused');
        });
    });

    /* Consent checkbox */
    $(document).on('change', '.ginput_container_consent input', function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('__checked');
        } else {
            $(this).parent().removeClass('__checked');
        }
    });

    $('.gfield_checkbox input:checked')
        .parent().addClass('__checked');
})(jQuery);